import { t, d, y } from "main/jsxRuntime.module";
import { m as membershipService, F as FORTHEM_TIER_NAME_ALLACCESS, a as FORTHEM_TIER_NAME_SUPPORT } from "main/membership-service";
function useMembership() {
  const [membershipStatus, setMembershipStatus] = t(d("not-member"), "membershipStatus");
  const [memberships, setMemberships] = t(d([]), "memberships");
  const [customerId, setCustomerId] = t(d(null), "customerId");
  const [isLoading, setIsLoading] = t(d(true), "isLoading");
  const [error, setError] = t(d(null), "error");
  const fetchMembershipStatus = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await membershipService.getCurrentMembershipStatus();
      setMembershipStatus(result.status);
      setMemberships(result.memberships);
      setCustomerId(result.customerId);
    } catch (err) {
      console.error("Error fetching membership status:", err);
      setError(err instanceof Error ? err.message : "Unknown error");
      setMembershipStatus("not-member");
      setMemberships([]);
      setCustomerId(null);
    } finally {
      setIsLoading(false);
    }
  };
  const refreshMembership = async () => {
    if (customerId) {
      membershipService.clearCache(customerId);
    }
    await fetchMembershipStatus();
  };
  y(() => {
    fetchMembershipStatus();
  }, []);
  return {
    membershipStatus,
    memberships,
    customerId,
    isLoading,
    error,
    refreshMembership
  };
}
async function hasDiscountMembershipActive() {
  try {
    const result = await membershipService.getCurrentMembershipStatus();
    if (!result.memberships || result.memberships.length === 0) {
      return false;
    }
    return result.memberships.some((membership) => {
      const tierName = membership.name;
      return tierName === FORTHEM_TIER_NAME_ALLACCESS || tierName === FORTHEM_TIER_NAME_SUPPORT;
    });
  } catch (error) {
    console.error("Error checking discount membership status:", error);
    return false;
  }
}
export {
  hasDiscountMembershipActive as h,
  useMembership as u
};
